<script lang="ts" generics="ITEM">
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchPageSizeSelector from './KpSearchPageSizeSelector.svelte';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    function onPageSizeChange(pageSize: number) {
        searchManager.newSearchWithPartialParams({pageSize});
    }
</script>

{#if exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('pageSizeChanging')}
    <KpSearchPageSizeSelector currentSize="{$lastSearch.result.pageSize}" availableSizes="{[10,20,30]}" on:change-page-size={(event) => onPageSizeChange(event.detail)}/>
{/if}
